import { z } from 'zod';
import { AccountGroup } from '$lib/accountGroup';

// Decodes a raw groupId string into an AccountGroup. Its input type is `string`, which keeps it
// usable in JSON-decoder contexts (e.g. file-reference decoders) that require a `Json`-serializable
// input.
const accountGroupSchema = z.string().transform((string) => {
  return AccountGroup.fromGroupId(string);
});

// Like accountGroupSchema, but also accepts an already-decoded AccountGroup and passes it through.
// This makes the schema idempotent — feeding it its own output succeeds — which is required by
// useQueryParam: it re-validates the in-memory state (which already holds AccountGroup instances)
// against the schema before writing it back to the URL. Do NOT use this in JSON-decoder contexts,
// as its input type (`string | AccountGroup`) is not `Json`-serializable.
const accountGroupParamSchema = z
  .union([z.instanceof(AccountGroup), z.string()])
  .transform((value) => (value instanceof AccountGroup ? value : AccountGroup.fromGroupId(value)));

export { accountGroupSchema, accountGroupParamSchema };
